export enum AzurePipelineStatusEventType {
    None = -1,
    BuildQueued = 0,
    BuildInProgress = 1,
    BuildFinished = 2,
    DeployStageStarted = 3,
    DeployStageFinished = 4
}

export interface AzurePipelineStatusViewModel {
    id: number;
    notificationId: number;
    eventType: AzurePipelineStatusEventType;
    message: string;
    detailedMessage: string;
    createdDate: Date;
    baseUrl: string;
    stageName: string;
}